import LastVersion from "./LastVersion";

export default LastVersion;